import {Directive, Input, TemplateRef, ViewContainerRef} from '@angular/core';
import {AuthenticationService} from '../services/authentication.service';

@Directive({
  selector: '[permission]',
})
export class PemrissionsDirective {

  constructor(private templateRef: TemplateRef<any>,
              private viewContainer: ViewContainerRef,
              public authenticationService: AuthenticationService) {
    this.authenticationService.authenticationEvents$.subscribe(
      () => {
        this.setPermissions(this.settedPermissions);
      }
    );
  }

  @Input()
  public permissionInverted = false;

  @Input()
  set permission(allowedPermissions: Array<string>) {
    this.settedPermissions = allowedPermissions;
    this.setPermissions(allowedPermissions);
  }

  private settedPermissions = [];

  private setPermissions(allowedPermissions: Array<string>) {
    const hasPermission = this.authenticationService.userHasOneOfThosePermissions(allowedPermissions);
    this.viewContainer.clear();
    if (this.permissionInverted !== hasPermission) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    }
  }
}
